import { render, staticRenderFns } from "./widgetGradientColorBarchart.vue?vue&type=template&id=96423172&scoped=true&"
import script from "./widgetGradientColorBarchart.vue?vue&type=script&lang=js&"
export * from "./widgetGradientColorBarchart.vue?vue&type=script&lang=js&"
import style0 from "./widgetGradientColorBarchart.vue?vue&type=style&index=0&id=96423172&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96423172",
  null
  
)

export default component.exports